import { useContext, useEffect } from "react";

import { HashRouter, Routes, Route } from "react-router-dom";

import { Layout } from "../";

import { UserContext } from "../../context/UserWrapper";
import { initApp, showSpinner } from "./handlers";
import Login from "../Login";
import Home from "../Home";
import Acta from "../Actas/Acta";
import Actas from "../Actas/index";
import Usuarios from "../Usuarios";
import Articulos from "../Articulos";
import Pagar from "../Pagar";
import MapaDeCalor from "../MapaDeCalor";
import Recibos from "../Recibos";
// import WebSocketListener from "../../context/WebsocketTest";
import HistorialInspectores from "../HistorialInspectores";
import EndpointsTablero from "../EndpointsTablero";
import ListadoDeActasVencidas from "../ListadoDeActasVencidas";
import ActasPorArticulo from "../ActasPorArticulo";

const Main = () => {
  const { actions, loading } = useContext(UserContext);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    initApp(actions);
  }, []);

  showSpinner(loading);

  return (
    <HashRouter>
      <Routes>
        <Route
          element={
            <>
              {/* <WebSocketListener /> */}
              <Layout perfil={actions.getPerfil()} />
            </>
          }
        >
          <Route path='/' element={<Home />} />
          <Route path='/actas/' element={<Actas />} />
          <Route path='/actas/:id' element={<Acta />} />
          <Route path='/articulos/' element={<Articulos />} />
          <Route path='/usuarios/' element={<Usuarios />} />
          <Route path='/mapa-de-calor' element={<MapaDeCalor />} />
          <Route path='/recibos' element={<Recibos />} />
          <Route path='/historial-inspectores' element={<HistorialInspectores />} />
          <Route path='/endpoints-tablero' element={<EndpointsTablero />} />
          <Route path='/listado-de-actas-vencidas' element={<ListadoDeActasVencidas />} />
          <Route path='/actas-por-articulo' element={<ActasPorArticulo />} />

          <Route path='*' element={"404"} />
        </Route>
        <Route path='/login' element={<Login />} />
        <Route path='/pagar' element={<Pagar />} />
      </Routes>
    </HashRouter>
  );
};

export default Main;
